// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface ILootTableBehavior {
  pools: any[];
}
